import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/sortByPrimary.svg'
import _imports_1 from '@/assets/arrowRight.svg'


const _hoisted_1 = { class: "maincontainer pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = {
  class: "row w-full mb-3 justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "bg-white border-lightgrey border rounded-t mt-4 w-full" }
const _hoisted_6 = { class: "flex p-3 items-center justify-between" }
const _hoisted_7 = { class: "flex justify-center items-center" }
const _hoisted_8 = { class: "flex justify-center items-center" }
const _hoisted_9 = { class: "flex ml-4" }
const _hoisted_10 = {
  key: 0,
  class: "initials cursor-pointer"
}
const _hoisted_11 = { class: "logContainer" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = {
  key: 0,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_14 = {
  key: 1,
  class: "mx-2 text-xs"
}
const _hoisted_15 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_16 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_17 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_18 = {
  key: 5,
  class: "mx-2 text-xs"
}
const _hoisted_19 = {
  key: 6,
  class: "mx-2 text-xs"
}
const _hoisted_20 = {
  key: 7,
  class: "mx-2 text-xs"
}
const _hoisted_21 = {
  key: 8,
  class: "mx-2 text-xs"
}
const _hoisted_22 = {
  key: 9,
  class: "mx-2 text-xs"
}
const _hoisted_23 = {
  key: 10,
  class: "mx-2 text-xs"
}
const _hoisted_24 = {
  key: 11,
  class: "flex text-xs"
}
const _hoisted_25 = {
  key: 12,
  class: "flex text-xs"
}
const _hoisted_26 = {
  key: 13,
  class: "flex text-xs"
}
const _hoisted_27 = {
  key: 14,
  class: "flex text-xs"
}
const _hoisted_28 = {
  key: 15,
  class: "flex text-xs"
}
const _hoisted_29 = {
  key: 16,
  class: "flex text-xs"
}
const _hoisted_30 = {
  key: 17,
  class: "flex text-xs"
}
const _hoisted_31 = {
  key: 18,
  class: "flex text-xs"
}
const _hoisted_32 = {
  key: 19,
  class: "flex text-xs"
}
const _hoisted_33 = {
  key: 20,
  class: "flex text-xs"
}
const _hoisted_34 = {
  key: 21,
  class: "flex text-xs"
}
const _hoisted_35 = {
  key: 22,
  class: "flex text-xs"
}
const _hoisted_36 = {
  key: 23,
  class: "flex text-xs"
}
const _hoisted_37 = {
  key: 24,
  class: "flex text-xs"
}
const _hoisted_38 = {
  key: 25,
  class: "flex text-xs"
}
const _hoisted_39 = {
  key: 26,
  class: "mx-2 text-xs"
}
const _hoisted_40 = {
  key: 27,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_41 = {
  key: 0,
  class: "flex pt-2 text-xs"
}
const _hoisted_42 = {
  key: 1,
  class: "flex text-xs pt-2"
}
const _hoisted_43 = {
  key: 2,
  class: "flex text-xs pt-2"
}
const _hoisted_44 = {
  key: 3,
  class: "flex text-xs pt-2"
}
const _hoisted_45 = {
  key: 4,
  class: "flex text-xs pt-2"
}
const _hoisted_46 = {
  key: 5,
  class: "flex text-xs pt-2"
}
const _hoisted_47 = {
  key: 6,
  class: "flex text-xs pt-2"
}
const _hoisted_48 = {
  key: 7,
  class: "flex text-xs pt-2"
}
const _hoisted_49 = {
  key: 8,
  class: "flex text-xs pt-2"
}
const _hoisted_50 = {
  key: 9,
  class: "flex text-xs pt-2"
}
const _hoisted_51 = {
  key: 10,
  class: "flex text-xs pt-2"
}
const _hoisted_52 = {
  key: 11,
  class: "flex text-xs pt-2"
}
const _hoisted_53 = {
  key: 12,
  class: "flex text-xs pt-2"
}
const _hoisted_54 = {
  key: 13,
  class: "flex text-xs pt-2"
}
const _hoisted_55 = {
  key: 14,
  class: "flex text-xs pt-2"
}
const _hoisted_56 = { class: "flex flex-col" }
const _hoisted_57 = { class: "font-semibold mt-1" }
const _hoisted_58 = { class: "font-semibold mt-1" }
const _hoisted_59 = {
  key: 15,
  class: "mt-4 ml"
}
const _hoisted_60 = {
  key: 0,
  class: "flex pt-1 text-xs"
}
const _hoisted_61 = { class: "capitalize font-semibold text-xs" }
const _hoisted_62 = { class: "capitalize font-semibold text-xs" }
const _hoisted_63 = { class: "capitalize font-semibold text-xs" }
const _hoisted_64 = {
  key: 1,
  class: "flex pt-1 text-xs"
}
const _hoisted_65 = { class: "capitalize font-semibold text-xs" }
const _hoisted_66 = {
  key: 2,
  class: "flex py-1"
}
const _hoisted_67 = { class: "capitalize font-semibold text-xs" }
const _hoisted_68 = { class: "flex rounded w-28 items-center regular text-xs" }
const _hoisted_69 = { class: "flex w-28 items-center justify-center regular pb-px" }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "font-semibold text-xs" }
const _hoisted_72 = { class: "flex rounded w-28 items-center regular text-xs" }
const _hoisted_73 = { class: "flex w-28 items-center justify-center regular pb-px" }
const _hoisted_74 = { key: 3 }
const _hoisted_75 = { class: "font-semibold text-xs" }
const _hoisted_76 = {
  key: 16,
  class: "flex text-xs mt-4"
}
const _hoisted_77 = {
  key: 17,
  class: "flex text-xs pt-2"
}
const _hoisted_78 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_79 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_80 = {
  key: 18,
  class: "flex text-xs pt-2"
}
const _hoisted_81 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_82 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_83 = {
  key: 19,
  class: "flex text-xs pt-2"
}
const _hoisted_84 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_85 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_86 = {
  key: 20,
  class: "flex text-xs pt-2"
}
const _hoisted_87 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_88 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_89 = {
  key: 21,
  class: "flex text-xs pt-2"
}
const _hoisted_90 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_91 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_92 = {
  key: 22,
  class: "flex text-xs pt-2"
}
const _hoisted_93 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_94 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_95 = {
  key: 23,
  class: "flex text-xs pt-2"
}
const _hoisted_96 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_97 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_98 = {
  key: 24,
  class: "flex text-xs pt-2"
}
const _hoisted_99 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_100 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_101 = {
  key: 25,
  class: "flex text-xs pt-2"
}
const _hoisted_102 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_103 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_104 = {
  key: 26,
  class: "flex text-xs pt-2"
}
const _hoisted_105 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_106 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_107 = {
  key: 27,
  class: "flex text-xs pt-2"
}
const _hoisted_108 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_109 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_110 = {
  key: 28,
  class: "flex text-xs pt-2"
}
const _hoisted_111 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_112 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_113 = {
  key: 29,
  class: "flex text-xs pt-2"
}
const _hoisted_114 = {
  key: 0,
  class: "capitalize font-semibold text-xs"
}
const _hoisted_115 = {
  key: 1,
  class: "capitalize font-semibold text-xs mr-2"
}
const _hoisted_116 = { key: 30 }
const _hoisted_117 = ["onClick"]
const _hoisted_118 = { key: 31 }
const _hoisted_119 = { class: "flex pt-2" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_122 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_123 = {
  key: 32,
  class: "flex items-center gap-2 mt-2"
}
const _hoisted_124 = { class: "text-xs text-justify" }
const _hoisted_125 = { class: "flex" }
const _hoisted_126 = { class: "flex rounded w-28 items-center regular text-xs" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { class: "flex w-28 items-center justify-center regular pb-px" }
const _hoisted_129 = {
  key: 1,
  class: "mx-4 flex items-center mt-4"
}
const _hoisted_130 = { class: "flex rounded w-28 items-center regular text-xs" }
const _hoisted_131 = { key: 0 }
const _hoisted_132 = { class: "flex w-28 items-center justify-center regular pb-px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, "Risk History - " + _toDisplayString(_ctx.mainRiskObject.risk), 1)
    ]),
    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "mt-3 text-xs" }, " Risk history is the process of identifying, assessing and controlling financial, legal, strategic and security risks to an organization’s capital and earnings. These threats, or risks, could stem from a wide variety of sources, including financial uncertainty, legal liabilities, strategic management errors, accidents and natural disasters.To reduce risk, an organization needs to apply resources to minimize, monitor and control the impact of negative events while maximizing positive events. A consistent, systemic and integrated approach to risk management can help determine how best to identify, manage and mitigate significant risks. ", -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "title ml-5" }, "Risk History", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.oldComments)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btnprimary w-24 flex taskEditButtons",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortWorkLog()))
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "h-3 mr-2.5 rotate-180"
                  }, null, -1),
                  _createTextVNode(" Newest ")
                ])))
              : _createCommentVNode("", true),
            (!_ctx.oldComments)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btnprimary w-24 flex taskEditButtons",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortWorkLog()))
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "h-3 mr-2.5"
                  }, null, -1),
                  _createTextVNode(" Oldest ")
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject, (work) => {
      return (_openBlock(), _createElementBlock("div", {
        key: work,
        class: "bg-white p-4 border-lightgrey border w-full"
      }, [
        _createElementVNode("div", _hoisted_9, [
          ((Object.keys(work).includes('createdBy')))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.extractInitials(work.name !=undefined?work.name:_ctx.getPersonName(work.createdBy))), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              ((Object.keys(work).includes('createdBy')))
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(work.name !=undefined?work.name:_ctx.getPersonName(work.createdBy)), 1))
                : _createCommentVNode("", true),
              ((((Object.keys(work).includes('previousStatus') && work.previousStatus == null) || !Object.keys(work).includes('previousStatus') ) && work.actionEntity == 10301))
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString("Created the risk status on")))
                : (work.actionEntity == 10302 && (!Object.keys(work).includes('previousStatus')))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString("Updated the Risk on")))
                  : (work.statusCode == 0 && work.action==10407)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString('Rejected the Reset Request Request on')))
                    : (work.statusCode == 0 && work.action==10403)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString('Rejected the Accept Request Request on')))
                      : (work.statusCode == 0 && work.action==10405)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString('Rejected the Mitigation Task Request on')))
                        : (work.statusCode == 0 && work.action==10404)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString('Rejected the Delete Request Request on')))
                          : ((work.previousStatus == work.updatedStatus) && work.action==10403)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString('Created the Accept Request to the risk on')))
                            : ((work.previousStatus == work.updatedStatus) && work.action==10405)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString('Created the Mitigate Tasks to the risk on')))
                              : ((work.previousStatus == work.updatedStatus) && work.action==10407)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString('Created the Reset Request to the risk on')))
                                : ((work.previousStatus == work.updatedStatus) && work.action==10404)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString('Created the Delete Request to the risk on')))
                                  : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.risk !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.risk !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[7] || (_cache[7] = [
                                        _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                      ])))
                                    : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskCategory !== undefined)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[8] || (_cache[8] = [
                                          _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                        ])))
                                      : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatSource !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatSource !== undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[9] || (_cache[9] = [
                                            _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                          ])))
                                        : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatCategory !== undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[10] || (_cache[10] = [
                                              _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                            ])))
                                          : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.vulnerability !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.vulnerability !== undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[11] || (_cache[11] = [
                                                _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                              ])))
                                            : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskOwner !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskOwner !== undefined)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[12] || (_cache[12] = [
                                                  _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                                ])))
                                              : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatEvent !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatEvent !== undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[13] || (_cache[13] = [
                                                    _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                                  ])))
                                                : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.financial !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.financial !== undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[14] || (_cache[14] = [
                                                      _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                                    ])))
                                                  : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.overallImpact !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.overallImpact !== undefined)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[15] || (_cache[15] = [
                                                        _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                                      ])))
                                                    : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.business !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.business !== undefined)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[16] || (_cache[16] = [
                                                          _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                                        ])))
                                                      : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.operations !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.operations !== undefined)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _cache[17] || (_cache[17] = [
                                                            _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                                          ])))
                                                        : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.legal !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.legal !== undefined)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[18] || (_cache[18] = [
                                                              _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                                            ])))
                                                          : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.likelihood !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.likelihood !== undefined)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[19] || (_cache[19] = [
                                                                _createElementVNode("p", { class: "px-2 text-xs" }, "Updated risk on", -1)
                                                              ])))
                                                            : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.priority !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.priority !== undefined)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, _cache[20] || (_cache[20] = [
                                                                  _createElementVNode("p", { class: "px-2 text-xs" }, "Updated the risk on", -1)
                                                                ])))
                                                              : (work.actionEntity == 10302 && (Object.keys(work).includes('isControlsExist') && work.isControlsExist!=undefined && work.isControlsExist==true))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _cache[21] || (_cache[21] = [
                                                                    _createElementVNode("p", { class: "px-2 text-xs" }, "Updated the risk on", -1)
                                                                  ])))
                                                                : (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString("Changed the risk status on"))),
              ((Object.keys(work).includes('createdAt')))
                ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                : _createCommentVNode("", true)
            ]),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.priority !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.priority !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[22] || (_cache[22] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "priority", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.risk !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.risk !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[23] || (_cache[23] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "risk", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskCategory !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[24] || (_cache[24] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "risk category", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatSource !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatSource !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, _cache[25] || (_cache[25] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "threat source", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatCategory !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _cache[26] || (_cache[26] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "threat category", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.vulnerability !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.vulnerability !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _cache[27] || (_cache[27] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "vulnerability", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskOwner !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskOwner !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, _cache[28] || (_cache[28] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "Risk Owner", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatEvent !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatEvent !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, _cache[29] || (_cache[29] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "Threat", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.financial !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.financial !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _cache[30] || (_cache[30] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "Financial", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.business !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.business !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, _cache[31] || (_cache[31] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "Startegic", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.operations !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.operations !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _cache[32] || (_cache[32] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "Operations", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.legal !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.legal !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, _cache[33] || (_cache[33] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "Compliance", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.likelihood !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.likelihood !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, _cache[34] || (_cache[34] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "likelihood", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.overallImpact !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.overallImpact !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, _cache[35] || (_cache[35] = [
                  _createElementVNode("p", { class: "capitalize font-semibold text-xs" }, "OverallImpact", -1),
                  _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)
                ])))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 
                            && Object.keys(work).includes('additionalInfo')
                            && work.additionalInfo?.controls !== undefined 
                            && work.additionalInfo.controls.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(work.additionalInfo.controls, (control) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: control.controlId,
                        class: "text-xs"
                      }, [
                        _createElementVNode("span", _hoisted_57, _toDisplayString(control.clientUniqueId.toUpperCase()), 1),
                        _createTextVNode(" -- " + _toDisplayString(control.controlTitle) + " -- ", 1),
                        _createElementVNode("span", _hoisted_58, _toDisplayString(control.weightage) + "%", 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (!Object.keys(work).includes('previousStatus')))
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(work.additionalInfo.risk.oldRisk[0]), (objKey) => {
                    return (_openBlock(), _createElementBlock("div", { key: objKey }, [
                      (objKey == 'riskOwner')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("p", _hoisted_61, _toDisplayString(objKey), 1),
                            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)),
                            _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.getPersonName(work.additionalInfo.risk.oldRisk[0][objKey])), 1),
                            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "px-3 flex items-center" }, [
                              _createElementVNode("img", { src: _imports_1 })
                            ], -1)),
                            _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.getPersonName(work.additionalInfo.risk.newRisk[0][objKey])), 1)
                          ]))
                        : (objKey == 'priority')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              _createElementVNode("p", _hoisted_65, _toDisplayString(objKey), 1),
                              _cache[38] || (_cache[38] = _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)),
                              (!isNaN(work.additionalInfo.risk.oldRisk[0][objKey]))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["flex items-center justify-center rounded-full ml-2 w-6 h-6", _ctx.colorPriorityBg(work.additionalInfo.risk.oldRisk[0][objKey])])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(_ctx.colorPriorityText(work.additionalInfo.risk.oldRisk[0][objKey]))
                                    }, _toDisplayString(_ctx.getPriorityLabel(work.additionalInfo.risk.oldRisk[0][objKey])), 3)
                                  ], 2))
                                : _createCommentVNode("", true),
                              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "px-3 flex items-center" }, [
                                _createElementVNode("img", { src: _imports_1 })
                              ], -1)),
                              (!isNaN(work.additionalInfo.risk.newRisk[0][objKey]))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["flex items-center justify-center rounded-full ml-2 w-6 h-6", _ctx.colorPriorityBg(work.additionalInfo.risk.newRisk[0][objKey])])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(_ctx.colorPriorityText(work.additionalInfo.risk.newRisk[0][objKey]))
                                    }, _toDisplayString(_ctx.getPriorityLabel(work.additionalInfo.risk.newRisk[0][objKey])), 3)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _createElementVNode("p", _hoisted_67, _toDisplayString(objKey), 1),
                              _cache[40] || (_cache[40] = _createElementVNode("p", { class: "px-2 text-xs" }, " is changed from ", -1)),
                              (!isNaN(work.additionalInfo.risk.oldRisk[0][objKey]))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["flex items-center cursor-pointer relative rounded w-28 regular text-xs h-5", _ctx.colorRiskParameterText(work.additionalInfo.risk.oldRisk[0][objKey])])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["w-full h-full absolute rounded", _ctx.colorRiskSeverity(work.additionalInfo.risk.oldRisk[0][objKey])])
                                    }, null, 2),
                                    _createElementVNode("div", _hoisted_68, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.oldRisk[0][objKey],objKey)), 1)
                                      ])
                                    ])
                                  ], 2))
                                : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("p", _hoisted_71, _toDisplayString(work.additionalInfo.risk.oldRisk[0][objKey]), 1)
                                    ])
                                  ])),
                              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "px-3 flex items-center" }, [
                                _createElementVNode("img", { src: _imports_1 })
                              ], -1)),
                              (!isNaN(work.additionalInfo.risk.newRisk[0][objKey]))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["flex items-center cursor-pointer relative rounded w-28 regular text-xs h-5", _ctx.colorRiskParameterText(work.additionalInfo.risk.newRisk[0][objKey])])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["w-full h-full absolute rounded", _ctx.colorRiskSeverity(work.additionalInfo.risk.newRisk[0][objKey])])
                                    }, null, 2),
                                    _createElementVNode("div", _hoisted_72, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.newRisk[0][objKey],objKey)), 1)
                                      ])
                                    ])
                                  ], 2))
                                : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                    _createElementVNode("p", _hoisted_75, _toDisplayString(work.additionalInfo.risk.newRisk[0][objKey]), 1)
                                  ]))
                            ]))
                    ]))
                  }), 128))
                ]))
              : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.priority !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.priority !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    (work.additionalInfo?.risk?.oldRisk?.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["rounded h-5 w-28 flex items-center justify-center", _ctx.colorPriorityBg(work.additionalInfo.risk.oldRisk[0].priority)])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.colorPriorityText(work.additionalInfo.risk.oldRisk[0].priority))
                          }, _toDisplayString(_ctx.getPriorityLabel(work.additionalInfo.risk.oldRisk[0].priority)||'N/A'), 3)
                        ], 2))
                      : _createCommentVNode("", true),
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "px-3 flex items-center" }, [
                      _createElementVNode("img", { src: _imports_1 })
                    ], -1)),
                    (work.additionalInfo?.risk?.newRisk?.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["rounded h-5 w-28 flex items-center justify-center", _ctx.colorPriorityBg(work.additionalInfo.risk.newRisk[0].priority)])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.colorPriorityText(work.additionalInfo.risk.newRisk[0].priority))
                          }, _toDisplayString(_ctx.getPriorityLabel(work.additionalInfo.risk.newRisk[0].priority)||'N/A'), 3)
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.risk !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.risk !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(work.additionalInfo.risk.oldRisk[0].risk||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[43] || (_cache[43] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(work.additionalInfo.risk.newRisk[0].risk||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskCategory !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(work.additionalInfo.risk.oldRisk[0].riskCategory||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[44] || (_cache[44] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(work.additionalInfo.risk.newRisk[0].riskCategory||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatSource !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatSource !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(work.additionalInfo.risk.oldRisk[0].threatSource||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[45] || (_cache[45] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(work.additionalInfo.risk.newRisk[0].threatSource||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatCategory !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(work.additionalInfo.risk.oldRisk[0].threatCategory||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[46] || (_cache[46] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(work.additionalInfo.risk.newRisk[0].threatCategory||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.vulnerability !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.vulnerability !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(work.additionalInfo.risk.oldRisk[0].vulnerability||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[47] || (_cache[47] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(work.additionalInfo.risk.newRisk[0].vulnerability||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskOwner !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskOwner !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.getPersonName(work.additionalInfo.risk.oldRisk[0].riskOwner?.value)||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[48] || (_cache[48] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(_ctx.getPersonName(work.additionalInfo.risk.newRisk[0].riskOwner?.value)||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatEvent !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatEvent !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(work.additionalInfo.risk.oldRisk[0].threatEvent||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[49] || (_cache[49] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(work.additionalInfo.risk.newRisk[0].threatEvent||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.financial !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.financial !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.oldRisk[0].financial,'financial')||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[50] || (_cache[50] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.newRisk[0].financial,'financial')||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.business !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.business !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.oldRisk[0].business,'business')||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[51] || (_cache[51] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.newRisk[0].business,'business')||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.operations !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.operations !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.oldRisk[0].operations,'operations')||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[52] || (_cache[52] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString(_ctx.getRiskValue( work.additionalInfo.risk.newRisk[0].operations,'operations')||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.legal !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.legal !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                  (work.additionalInfo?.risk?.oldRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_108, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.oldRisk[0].legal,'legal')||'N/A'), 1))
                    : _createCommentVNode("", true),
                  _cache[53] || (_cache[53] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                  (work.additionalInfo?.risk?.newRisk?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(_ctx.getRiskValue( work.additionalInfo.risk.newRisk[0].legal,'legal')||'N/A'), 1))
                    : _createCommentVNode("", true)
                ]))
              : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.likelihood !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.likelihood !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                    (work.additionalInfo?.risk?.oldRisk?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.oldRisk[0].likelihood,'likelihood')||'N/A'), 1))
                      : _createCommentVNode("", true),
                    _cache[54] || (_cache[54] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                    (work.additionalInfo?.risk?.newRisk?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.newRisk[0].likelihood,'likelihood')||'N/A'), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.overallImpact !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.overallImpact !== undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                      (work.additionalInfo?.risk?.oldRisk?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.oldRisk[0].overallImpact,'overallImpact')||'N/A'), 1))
                        : _createCommentVNode("", true),
                      _cache[55] || (_cache[55] = _createElementVNode("p", { class: "px-2 text-xs" }, "to", -1)),
                      (work.additionalInfo?.risk?.newRisk?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, _toDisplayString(_ctx.getRiskValue(work.additionalInfo.risk.newRisk[0].overallImpact,'overallImpact')||'N/A'), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
            (Object.keys(work).includes('insertedIds'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(work.insertedIds, (task) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: task,
                      class: "flex pt-2"
                    }, [
                      _cache[56] || (_cache[56] = _createElementVNode("p", { class: "text-xs" }, "Approval:", -1)),
                      _createElementVNode("p", {
                        class: "font-semibold px-2 hover:underline cursor-pointer text-xs",
                        onClick: ($event: any) => (_ctx.openTaskEdit(task))
                      }, _toDisplayString(_ctx.getTaskInfo(task)), 9, _hoisted_117),
                      _cache[57] || (_cache[57] = _createElementVNode("p", { class: "text-xs" }, _toDisplayString("is Created"), -1))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (Object.keys(work).includes('taskId'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                  _createElementVNode("div", _hoisted_119, [
                    _cache[58] || (_cache[58] = _createElementVNode("p", { class: "text-xs" }, "TaskId:", -1)),
                    _createElementVNode("p", {
                      class: "font-semibold px-2 hover:underline cursor-pointer text-xs",
                      onClick: ($event: any) => (_ctx.openTaskEdit(work.taskId))
                    }, _toDisplayString(_ctx.getTaskInfo(work.taskId)), 9, _hoisted_120),
                    (work.statusCode == 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_121, _toDisplayString("is closed by Accepting")))
                      : (work.statusCode == 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_122, _toDisplayString("is closed by Rejecting")))
                        : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            ((work.justification != undefined && work.justification != '') || (work.additionalInfo && work.additionalInfo.justification))
              ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                  _cache[59] || (_cache[59] = _createElementVNode("p", { class: "font-semibold text-xs" }, "Justification :", -1)),
                  _createElementVNode("p", _hoisted_124, _toDisplayString(work.justification || work.additionalInfo.justification), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_125, [
              ((Object.keys(work).includes('previousStatus') && (work.previousStatus != work.updatedStatus && work.previousStatus!=null)) || (!work.previousStatus==null && work.actionEntity == 10301))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "relative mt-4",
                    onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doFalse()))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex items-center cursor-pointer relative rounded w-28 regular text-xs h-5", _ctx.colorRiskText(work.previousStatus)])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-full h-full absolute rounded", _ctx.colorRiskBg(work.previousStatus)])
                      }, null, 2),
                      _createElementVNode("div", _hoisted_126, [
                        (!isNaN(work.previousStatus))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                              _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.getRiskStatusLabel(work.previousStatus)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 2)
                  ], 32))
                : _createCommentVNode("", true),
              ((Object.keys(work).includes('previousStatus') && (work.previousStatus != work.updatedStatus && work.previousStatus!=null)) || (!work.previousStatus==null))
                ? (_openBlock(), _createElementBlock("div", _hoisted_129, _cache[60] || (_cache[60] = [
                    _createElementVNode("img", { src: _imports_1 }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              ((work.previousStatus != work.updatedStatus))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "relative mt-4",
                    onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doFalse()))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex items-center cursor-pointer relative rounded w-28 regular text-xs h-5", _ctx.colorRiskText(work.updatedStatus)])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-full h-full absolute rounded", _ctx.colorRiskBg(work.updatedStatus)])
                      }, null, 2),
                      _createElementVNode("div", _hoisted_130, [
                        (!isNaN(work.updatedStatus))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                              _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.getRiskStatusLabel(work.updatedStatus)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 2)
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}